import styled from 'styled-components'
import { Dialog } from '@mui/material'

export const YourProfileContainer = styled.div`
  display: flex;
  @media (orientation: landscape) {
    padding: 5% 20% 0% 10%;
  }
  @media (orientation: portrait) {
    padding: 10% 10% 10% 10%;
  }
  
  @media (max-width: 768px) {
    padding: 5% 5% 5% 5%;
  }
  
  @media (max-width: 480px) {
    padding: 15px;
  }
`

export const YourProfileContent = styled.div`
  width: 100%;
  /* Glass effect container */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
  
  @media (max-width: 768px) {
    padding: 24px;
    border-radius: 20px;
  }
  
  @media (max-width: 480px) {
    padding: 20px;
    border-radius: 16px;
  }
`

export const YourProfileTitle = styled.div`
  color: #fff;
  font-size: 30px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media (min-width: 1280px) {
    font-size: 38px;
  }
`

export const SpaceBetweenFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const EditIcon = styled.img`
  width: 25.372px;
  height: 25.372px;
  flex-shrink: 0;
  cursor: pointer;
  @media (orientation: landscape) {
    display: none;
  }
`

export const YourProfileForm = styled.div`
  width: 100%;
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  gap: 25px;
`

// gender selection components

export const GenderSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 12px;
  /* Glass effect */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-radius: 16px;
  min-width: 200px;
  
  @media (max-width: 480px) {
    padding: 16px;
    gap: 10px;
    min-width: 180px;
  }
`

export const GenderSelectOptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${(props) => (props?.isSelected ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.7)')};
  font-size: 18px;
  font-family: Outfit;
  font-style: normal;
  font-weight: ${(props) => (props?.isSelected ? '600' : '400')};
  line-height: normal;
  letter-spacing: 0.5px;
  padding: 10px 14px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${(props) => 
    props?.isSelected 
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%)'
      : 'transparent'
  };
  
  &:hover {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%);
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
    padding: 8px 12px;
  }
`

export const SelectOptionPicture = styled.img`
  width: 15.372px;
  height: 15.372px;
  flex-shrink: 0;
`

export const SelectOptionCategoryPicture = styled.img`
  width: 30.683px;
  height: 30.683px;
  flex-shrink: 0;
  border-radius: 50%;
  margin-right: 10px;
`

// content languages selection components

export const ContentLanguagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
  /* Glass effect */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-radius: 16px;
  min-width: 280px;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
  
  @media (max-width: 480px) {
    padding: 12px;
    gap: 6px;
    min-width: 240px;
    max-height: 280px;
  }
`

export const ContentLanguagesOptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: ${(props) => (props?.isSelected ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.7)')};
  font-size: 16px;
  font-family: Outfit;
  font-style: normal;
  font-weight: ${(props) => (props?.isSelected ? '600' : '400')};
  line-height: normal;
  padding: 10px 12px;
  border-radius: 12px;
  transition: all 0.2s ease;
  background: ${(props) => 
    props?.isSelected 
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%)'
      : 'transparent'
  };

  &:hover {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%);
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 10px;
  }
`

export const ContentLanguagesOptionExtraText = styled.div`
  color: #8e8e8e;
  font-size: 16px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 10px;
`

// content preferences selection components

export const ContentPreferencesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
  /* Glass effect */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-radius: 16px;
  min-width: 280px;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
  
  @media (max-width: 480px) {
    padding: 12px;
    gap: 6px;
    min-width: 240px;
    max-height: 280px;
  }
`

export const ContentPreferencesOptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: ${(props) => (props?.isSelected ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.7)')};
  font-size: 16px;
  font-family: Outfit;
  font-style: normal;
  font-weight: ${(props) => (props?.isSelected ? '600' : '400')};
  line-height: normal;
  padding: 10px 12px;
  border-radius: 12px;
  transition: all 0.2s ease;
  background: ${(props) => 
    props?.isSelected 
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%)'
      : 'transparent'
  };
  
  &:hover {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%);
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 10px;
  }
`

export const OptionSeparationLine = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.1);
  margin: 4px auto;
  
  @media (max-width: 480px) {
    margin: 2px auto;
  }
`

//

export const YourProfileActions = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  gap: 40px;
  cursor: pointer;
`

export const EditButton = styled.button`
  color: #fff;
  font-size: 17px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 8px 36px;
  border-radius: 52px;
  border: 2px solid #fff;
  @media (min-width: 1280px) {
    color: #fff;
    font-size: 22px;
    font-family: Outfit;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 8px 48px;
  }
`

export const SaveButton = styled.button`
  color: #fff;
  font-size: 17px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 8px 36px;
  background: ${(props) => (props?.disabled ? '#4D4D4D' : '#09B41A')};
  border-radius: 52px;
  @media (min-width: 1280px) {
    color: #fff;
    font-size: 22px;
    font-family: Outfit;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 8px 48px;
  }
`

export const CancelButton = styled.div`
  color: #fff;
  font-size: 16px;
  font-family: Outfit;
  font-weight: 600;
  text-decoration: underline;
`

export const StyledAgeGenderContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
`

export const StyledEditIcon = styled.img`
  &:hover {
    cursor: pointer;
  }
`

export const StyledGenderDialog = styled(Dialog)`
  .MuiPaper-root {
    height: 390px;
    width: 809px;
    max-width: 809px;
    background: #323236;
    border-radius: 20px;
    font-family: Outfit;
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 30px;
    text-align: center;
    color: #ffffff;
    padding: 44px;
  }
`

export const GenderModalHeader = styled.div`
  padding-top: 60px;
`

export const GenderModalOptions = styled.div`
  padding-top: 75px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`

export const GenderOption = styled.div`
  width: 183px;
  height: 74px;
  border: ${(props) => (props.isSelected ? '1px solid #A2FF93' : '1px solid #818181')};
  border-radius: 20px;
  font-weight: 400;
  font-size: 21px;
  line-height: 21px;
  color: ${(props) => (props.isSelected ? '#A2FF93' : '#818181')};
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
`

export const StyledGenderIcon = styled.img`
  padding-right: 11px;
`

export const StyledCancelIcon = styled.img`
  height: 50px;
  width: 50px;
  position: absolute;
  right: 44px;
  &:hover {
    cursor: pointer;
  }
`

// export const YourProfileActions = styled.div`
//     gap: 111px;
//     display: flex;
//     flex-direction: row;
//     align-items: center;
// `;
